import React from 'react';
import Link from '../link';

// Same geometry as the design-system IconChevR (Icons.jsx is a dormant global-bundle
// script without exports, so the path is inlined here).
function CrumbSeparator() {
  return (
    <svg
      width={16}
      height={16}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={1.7}
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden='true'
    >
      <path d='M9 6l6 6-6 6' />
    </svg>
  );
}

// Bravo breadcrumb. items: [{ text, title, link, url }] — navigation goes through the
// redux-connected Link element, so crumb behavior matches legacy links. An item marked
// `isCurrentPage: true` is the page being looked at: it is rendered as plain text rather
// than a link, so the trail says where you are and every clickable crumb goes up a level.
function Breadcrumb({ items }) {
  return (
    <div className='breadcrumb'>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && <CrumbSeparator />}
          {item.isCurrentPage ? (
            <span
              className='crumb-current-page'
              title={item.title}
              aria-current='page'
            >
              {item.text}
            </span>
          ) : (
            <Link
              linktext={item.text}
              title={item.title}
              link={item.link}
              className='crumb'
              url={item.url}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

export default Breadcrumb;
